// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__IZ9q7","info":"PatientInfo_info__QTgl7"};